import { Component, Injector, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ManagementType } from '../../../shared/enum/managementType';
import { ActionType } from '../../../shared/enum/actionType';
import { Subject, Subscription, map, debounceTime } from 'rxjs';
import { ComponentService } from '../../../shared/abstract/component.service';
import { GeneralQueryModel } from '../../../shared/model/general-query-model';
import { RequestService } from '../../../shared/services/request.service';
import { ModalComponent } from '../../../shared/widgets/modal/modal.component';
import { MatDialog } from '@angular/material/dialog';
import { User } from '../../../shared/entities/user';
import { RoleEnums } from '../../../shared/enum/authorize';
import { ImportModel } from '../../../shared/model/import-model';
import { ResultCode } from '../../../shared/enum/result-code';

interface SearchParams {
  searchTerm: string | boolean;
  all: boolean;
  columnName?: string;
}
@Component({
  selector: 'app-support-management',
  templateUrl: './support-management.component.html',
  styleUrl: './support-management.component.css'
})
export class SupportManagementComponent extends ComponentService<any> implements OnInit {
  constructor(injector: Injector, private _request: RequestService, private _dialog: MatDialog) {
    super(injector);
    // Debounce mekanizması
    this.searchSubject.pipe(debounceTime(600)).subscribe((searchParam) => {
      this.filter(searchParam.searchTerm, searchParam.columnName);
    });
  }

  dataSource = new MatTableDataSource<any>();
  currentCompany;
  userSearchLength;
  properties: any[] = [];
  searchValues: any[] = [];
  pageIndex = 0;
  pageSize = 5;
  currentPage = 0;
  totalPages = 0;
  maxVisibleButtons = 5;
  Math = Math;
  isSideNavOpen = false;
  selectedManagementType!: ManagementType;
  selectedActionType!: ActionType;
  ManagementType = ManagementType;
  ActionType = ActionType;
  inputValues: { [key: string]: string | boolean } = {};
  searchInput: string = '';
  private searchSubject: Subject<SearchParams> = new Subject();
  displayedColumns: string[] = ['supportTitle', 'options'];
  selectedSupport?: any;
  subDataSource = new MatTableDataSource<any>();
  roleEnum = RoleEnums;
  public keyUpEvent = new Subject<any>();
  private _keyUpEventSubscription!: Subscription;
  isSelectionMade = false;
  importData: ImportModel = new ImportModel();
  returnBase64;
  comingBase64;

  propertiesForColumn: any[] = [];
  searchValuesForColumn: any[] = [];


  ngOnInit(): void {
    if (
      this._appsService?.existCurrentProject?.companyId &&
      this._appsService?.existCurrentProject.projectId
    ) {
      this.currentProject = this._appsService.existCurrentProject;
      this.currentCompany = this._appsService.existCurrentCompany;
      this.getCurrentCompanyProject();
      this.managementConfig();
    } else {
      this.currentCompany = this._appsService.existCurrentCompany;
    }
    this.cPSubs = this._appsService.currentProject.subscribe((project) => {
      this.currentProject = project;
      this.getCurrentCompanyProject();
      this.managementConfig();
    });
  }

  managementConfig() {
    this.getPaginatedQuery();
  }

  getPaginatedQuery() {
    let model: GeneralQueryModel = new GeneralQueryModel();

    model.companyId = this.globalCompanyId;
    model.propertyNames = this.propertiesForColumn;
    model.searchValues = this.searchValuesForColumn;
    model.and = true;
    model.orderColumn = '';
    model.order = 'asc';
    model.index = this.pageIndex;
    model.size = this.pageSize;

    this._request
      .getPaginateSupport(model)
      .then((_) => {
        if (_.items) {
          this.dataSource.data = _.items;
          this.userSearchLength = _.count;
        }
      })
      .catch((err) => {
        this.MessageBox(err.message ?? '', 'warn', 'center');
      })
      .finally(() => {
        this.updateTotalPages();
      });
  }

  refreshTableAfterAction() {
    this.currentPage = 0;
    this.pageIndex = 0;
    this.getPaginatedQuery();
    this.updateTotalPages();
  }

  onInputChange(event: Event | any, all: boolean = false, columnName?: string): void {
    let searchTerm: string | boolean = '';

    if (event && event.target) {
      const inputElement = event.target as HTMLInputElement;
      searchTerm = inputElement.value;
    } else {
      searchTerm = event;
    }
    this.searchSubject.next({ searchTerm, all, columnName });
  }

  filter(searchTerm: string | boolean, columnName?: string): void {
    if (columnName) {
      const propertyIndex = this.propertiesForColumn.indexOf(columnName);

      if (propertyIndex !== -1) {
        if (searchTerm === '' || searchTerm === null || searchTerm === undefined) {
          this.propertiesForColumn.splice(propertyIndex, 1);
          this.searchValuesForColumn.splice(propertyIndex, 1);
        } else {
          this.searchValuesForColumn[propertyIndex] = searchTerm;
        }
      } else {
        this.propertiesForColumn.push(columnName);
        const newPropertyIndex = this.propertiesForColumn.indexOf(columnName);
        this.searchValuesForColumn[newPropertyIndex] = searchTerm;
      }
    }

    this.currentPage = 0;
    this.pageIndex = 0;

    // Güncellenen arama kriterlerine göre verileri al
    this.getPaginatedQuery();
  }
  get visiblePageNumbers(): number[] {
    const start = Math.max(
      0,
      Math.min(
        this.currentPage - Math.floor(this.maxVisibleButtons / 2),
        this.totalPages - this.maxVisibleButtons
      )
    );
    return Array.from(
      { length: Math.min(this.maxVisibleButtons, this.totalPages) },
      (_, i) => start + i + 1
    );
  }

  onPageChange(pageIndex: number) {
    if (pageIndex >= 0 && pageIndex < this.totalPages) {
      this.currentPage = pageIndex;
    }
    this.pageIndex = pageIndex;
    this.getPaginatedQuery();
  }

  updatePageSize(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    this.pageSize = parseInt(selectElement.value, 10);
    this.refreshTableAfterAction();
    this.currentPage = 0;
    this.pageIndex = 0;
    this.getPaginatedQuery();
  }

  updateTotalPages() {
    this.totalPages = Math.ceil(this.userSearchLength / this.pageSize);
  }

  deleteQA(element) {
    const dialogRef = this._dialog.open(ModalComponent, {
      width: '400px',
      data: {
        type: 'confirm',
        title: 'deleteQA',
        body: 'deleteQAConfirm',
        ok: 'confirm',
        cancel: 'cancel',
        color: 'warn'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this._request.deleteSupport(element.id).then((res) => {
          if (res.code == 1) {
            this.dataSource.data = this.dataSource.data.filter(u => u.id != element.id);
            this.MessageBox(res.message ?? '', 'primary', 'center');
          }
          else if (res.code == 2) {
            this.MessageBox(res.message ?? '', 'orange', 'center');
          }
          else {
            this.MessageBox(res.message ?? '', 'warn', 'center');
          }
        }).catch((err) => {
          let comingTransl = this.languageKey('unexpectedError');
          this.MessageBox(comingTransl, 'warn', 'center');
        });
        this._appsService.logInfo("Yardım silindi");
      }
    })
  }

  openSideNav(
    managementType: ManagementType,
    actionType: ActionType,
    support?: any

  ) {
    this.selectedManagementType = managementType;
    this.selectedActionType = actionType;
    this.isSideNavOpen = true;
    this.selectedSupport = support ? { ...support } : null;
    this._appsService.logInfo("Yardım " + this.languageKey(actionType) + " açıldı");
  }

  uploadedData;
  base64ExcelData;
  fileUpload(file) {
    const target: DataTransfer = <DataTransfer>(file.target);
    if (target.files.length !== 1) {
      let excelErrorMessage = this.languageKey('excelErrorMessage');
      this.MessageBox(excelErrorMessage, 'orange', 'center');

    }
    this.uploadedData = file.target.files[0];
    this.getBase64(file.target.files[0]).then((res) => {
      this.base64ExcelData = res;
    }).finally(() => {
      this.importData.excelBase64 = this.base64ExcelData;
      this.importData.companyId = this._appsService.existCurrentProject.companyId;
      this._request.importSupportFromExcel(this.importData).then((resv2) => {
        if (resv2.code == 1) {
          this.returnBase64 = resv2.data;
          this.MessageBox(resv2.message ?? '', 'primary', 'center');

          this._request.getSupports().then((res) => {

            if (res != null) {
              this.dataSource.data = res;
            }

          }).catch((err) => {
            let unexpectedError = this.languageKey('unexpectedError');

            this.MessageBox(unexpectedError ?? '', 'warn', 'center');
          });
        }
        else if (resv2.code == 2) {
          this.MessageBox(resv2.message ?? '', 'orange', 'center');
          return;
        }
        else {
          this.MessageBox(resv2.message ?? '', 'warn', 'center');
        }
      }).finally(() => {
        let excelResult = this.languageKey('excelResult');
        this.exportExcelv1(this.returnBase64, excelResult);
      });
    });
    file.target.value = '';
    this._appsService.logInfo("Yardım exceli yüklendi");
  }

  exportExcel() {
    this._request.getSupportExcelTemplate().then((res) => {
      if (res.code == ResultCode.Success) {
        this.comingBase64 = res.data;
      }
    }).finally(() => {
      let exampleSupportExcel = this.languageKey("exampleSupportExcel");
      this.exportExcelv1(this.comingBase64, exampleSupportExcel);

    }).catch((err) => {
      this.MessageBox(err.message ?? '', 'warn', 'center');
    });
    this._appsService.logInfo("Örnek yardım exceli indirildi");
  }
}
